import { getBloodTrackerByUserId, updateBloodTrackerByUserId } from "@/utils/apis/dna-test-tracker";
import { BloodTestTrackingStatus } from "@/utils/enums/TrackingStatus";
import { useAuthStore } from "@/utils/stores/useAuthStore";
import { useTrackersStore } from "@/utils/stores/useTrackersStore";
import { useCallback } from "react";
import { BloodTestTrackingCategory } from "../types/BloodTestTrackingCategory";

export const useBloodTracker = () => {
    const { trackers, updateTrackers } = useTrackersStore()
    const { auth } = useAuthStore();

    const bloodTracker = trackers.bloodStatus
    const userId = auth.userId
    const idToken = auth.idToken;

    const fetchBloodTracker = useCallback(async () => {
        if (!userId || !idToken) return;

        try {
            const trackers = await getBloodTrackerByUserId(userId, idToken);
            if (trackers) {
                console.log("[Blood Tracker] Updating status from API");
                const newBloodStatus = trackers[0].tracking_status;
                updateTracker(newBloodStatus );
            } else {
                console.warn(`[Blood Tracker] No tracker found for user: ${userId}`);
            }
        } catch (error) {
            console.error(
                "[Blood Tracker] Error fetching tracker:",
                error instanceof Error ? error.message : error
            );
        }
    }, [userId, idToken, bloodTracker, updateTrackers])

    const updateTracker = useCallback(
        (newStatus: BloodTestTrackingStatus, onSuccess?: () => void) => {
            if (newStatus === bloodTracker) {
                console.log(`[Blood Tracker] No update needed: status is already "${bloodTracker}"`)
                return
            }

            if (!userId ||!idToken) {
                console.error("[Blood Tracker] Missing user ID or ID token, cannot update tracker")
                return
            }

            console.log(`[Blood Tracker] Updating tracker to "${newStatus}"...`)

            updateBloodTrackerByUserId(
                userId,
                idToken,
                newStatus,
                (tracker) => {
                    const newStatus = tracker.tracking_status
                    updateTrackers({bloodStatus: newStatus})
                    console.log(`[Blood Tracker] Successfully updated to "${tracker.tracking_status}"`)

                    if (onSuccess) onSuccess();
                },
                (error) => {
                    console.log(error)
                  },
            )

        }, [bloodTracker, idToken, updateTrackers]
    )

    const getBloodTestCategory = () => {
            if (bloodTracker === BloodTestTrackingStatus.ReportGenerated) {
                return BloodTestTrackingCategory.ResultsReady
            }
            if (
                bloodTracker === BloodTestTrackingStatus.DeliveredToLab
            ) {
                return BloodTestTrackingCategory.InLaboratory
            }
            return BloodTestTrackingCategory.Home
        }

    return { bloodTracker, fetchBloodTracker, updateTracker, getBloodTestCategory}
}